import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import './style.css'
import chatLogo from '../../../assets/images/logo/chatbot-icon.png';

const FloatingChatButton = ({ customOnClick }) => {
  const navigate = useNavigate()
  const location = useLocation()
  
  // Hide the button if we're on the AI chat page
  if (location.pathname === '/ai-chat') {
    return null
  }
  
  const handleClick = () => {
    if (customOnClick) {
      customOnClick()
    } else {
      navigate('/ai-chat')
    }
  }

  return (<>
    <div className="floating-chat-button" onClick={handleClick}>
      <div className="chat-icon">
        <img src={chatLogo} alt="Ask IPEans AI" />
      </div>
      <div className="chat-text">Ask IPEans AI</div>
    </div>
    </>
  )
}

export default FloatingChatButton